export default "__VITE_ASSET__BfDD1NBw__"